export default __webpack_public_path__ + "static/media/certified.a974c4e1.svg";